import { CREATE_LIST, OPEN_LIST, CLOSE_LIST, CLEAR_LIST } from './types';

export const createList = (list, title) => ({
  type: CREATE_LIST,
  payload: {
    list: list, 
    title: title
  }
});

export const openList = () => ({
  type: OPEN_LIST
});

export const closeList = () => ({
  type: CLOSE_LIST
});

export const clearList = () => ({
  type: CLEAR_LIST
});
